import { Button } from "components/Button/Button"
import { IS_LOCAL } from "configs/AppConfig"
import { useTranslate } from "hooks/useTranslate"
import { FallbackProps } from "react-error-boundary"

export const ErrorFallback = ({ error, resetErrorBoundary }: FallbackProps) => {
  const t = useTranslate()

  return (
    <div className="flex min-h-[400px] flex-col items-center justify-center space-y-4 p-8">
      <div className="shadow-sm rounded-lg bg-red-50 p-6">
        <h2 className="text-lg mb-2 font-semibold text-red-800">{t("error.fallback.title")}</h2>
        <p className="mb-4 text-red-600">{t("error.fallback.description")}</p>

        {IS_LOCAL && (
          <details className="mb-4 max-w-[600px] text-left">
            <summary className="text-sm cursor-pointer text-red-700 hover:text-red-800">Show error details</summary>
            <pre className="text-xs mt-2 overflow-auto rounded bg-red-100 p-2 text-red-800">
              {error instanceof Error ? (
                <>
                  {error.message}
                  {error.stack && (
                    <>
                      <br />
                      <br />
                      {error.stack}
                    </>
                  )}
                </>
              ) : (
                error
              )}
            </pre>
          </details>
        )}

        <Button onClick={resetErrorBoundary} variant="primary">
          {t("error.fallback.tryAgain")}
        </Button>
      </div>
    </div>
  )
}
